import { getCurrencySymbol } from 'utils/common';

const AMOUNT_FORMAT: Intl.NumberFormatOptions = { minimumFractionDigits: 2, maximumFractionDigits: 2 };

export const formatProductsTotal = (total: number | null | undefined, currency: string | undefined): string => {
    if (total === undefined || total === null) return '';

    const amount = total.toLocaleString('en-GB', AMOUNT_FORMAT);
    if (!currency) return amount;

    const currencyLabel = getCurrencySymbol(currency) || currency.toUpperCase();

    return `(${currencyLabel}) ${amount}`;
};
